import { CommonLayout, CommonLayoutForInvestor } from '../commonComponents';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import UpdateBank from '.';
import ViewBank from './ViewBank';
import AddBank from './AddBank';
import VerifyAddBankOtp from './VerifyAddBankOtp';
import { useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import { USER_ROLES } from '../../utils/constant';


const routerList = [
    {
        name: 'Add Update Banks',
        path: "updateBank",
        component: UpdateBank,
    },
    {
        name: 'View Banks',
        path: "viewBank",
        component: ViewBank,
    },
    {
        name: 'Add Bank',
        path: "addbank",
        component: AddBank,
    },
    {
        name: 'Send to BSE OTP',
        path: "otp-screen",
        component: VerifyAddBankOtp,
    }
]

function BankRoutes(): JSX.Element {
    const { path } = useRouteMatch();

    return (
        <Switch>
            {
                routerList.map((item, index) => <Route
                    exact
                    key={index}
                    path={`${path}/${item.path}`}
                    component={item.component}
                />)
            }
        </Switch>
    );
}

const BanksLayout = ({ children }: any) => {
    const { role = '' } = useSelector((state: RootStateType) => state.auth);
    return role === USER_ROLES.INVESTOR ? (
        <CommonLayoutForInvestor>
            {children}
        </CommonLayoutForInvestor>
    ) : (
        <CommonLayout>
            {children}
        </CommonLayout>
    )
}
export default function BanksRouter(): JSX.Element {

    return (
        <>

            <BanksLayout>
                <BankRoutes />
            </BanksLayout>
        </>
    )
}